
import {Component, EventEmitter,OnChanges, OnInit,Input,Output } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { BaseService } from '../../services/base.service';
import { CommonService } from '../../../shared/services/common.service';
import { Router } from '@angular/router';

@Component({
  selector: 'ara-approver-log',
  templateUrl: './approver-log.component.html',
  styleUrls: ['./approver-log.component.css']
})
export class ApproverLogComponent implements OnInit {
    @Input() RiskId: any;
    ApproverLogData:any;
    ApprovalsList : any;
  constructor(private translate: TranslateService, private baseService: BaseService,private commonservice : CommonService) {
   
  }

  ngOnInit() 
  {
    const apiRequest = {
        Model: {
          "RiskId": this.RiskId,   
       }
      };
  
      this.commonservice.getRiskApproverLog(apiRequest,this.callbackMethodForgetRiskApproverLog.bind(this));  
  }

  callbackMethodForgetRiskApproverLog(response){
    if(response.Success)
    this.ApproverLogData = response.Result.GetRiskApproverLogData;
    this.ApprovalsList = response.Result.Approvals;
  }

}